// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.

$(document).on("turbo:load", function() {
  $("#address_zipcode").jpostal({
    // 郵便番号の入力欄が１つの場合
    // 111-1111と1111111のどちらの入力形式でも住所を自動入力してくれる
    postcode : [ "#user_postal_code" ],

    // 入力項目フォーマット
    //   %3  都道府県
    //   %4  市区町村
    //   %5  町域
    //   %6  大口事業所の番地
    //   %7  大口事業所の名称
    address  : {
      "#user_address" : "%3%4%5%6%7"
    }
  });

  $("#user_place_id").select2({placeholder: "弁護士会", allowClear: true});

  $(".hide-panel").hide();
  $(".show-panel").on('click', function() {
    $(this).next().toggle(200);
    $("span", this).toggleClass("fa-minus-square");
    $("span", this).toggleClass("fa-plus-square");
  });

  // Auto furigana
  $.fn.autoKana('#user_name', '#user_name_kana', {});

  // カレンダー色セレクトにSelect2を適用
  const calendarColorSelect = $(".calendar-color-select");
  if (calendarColorSelect.length > 0) {
    const colorMap = calendarColorSelect.data('colors');

    calendarColorSelect.select2({
      minimumResultsForSearch: -1,  // 検索ボックスを非表示
      templateResult(state) {
        if (!state.id) {
          return state.text;
        }

        const colorHex = colorMap[state.id];
        const $state = $(
          '<span><span class="color-indicator" style="background-color: ' + colorHex + ';"></span> ' + state.text + '</span>'
        );
        return $state;
      },

      templateSelection(state) {
        if (!state.id) {
          return state.text;
        }

        const colorHex = colorMap[state.id];
        const $state = $(
          '<span><span class="color-indicator" style="background-color: ' + colorHex + ';"></span> ' + state.text + '</span>'
        );
        return $state;
      }
    });
  }
});
